export default ({
  EDITING: 0,
  FAILED: 1,
  SAVED: 2,
  UPDATING: 3,
});
